'use client';

import { useSyncExternalStore } from 'react';

// Match the app shell's lg breakpoint without assuming a viewport during hydration.
const DESKTOP_QUERY = '(min-width: 64rem)';

function subscribe(onChange: () => void) {
  const query = window.matchMedia(DESKTOP_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

function getSnapshot() {
  return window.matchMedia(DESKTOP_QUERY).matches;
}

function getServerSnapshot(): boolean | undefined {
  return undefined;
}

export function useDesktopViewport() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
